import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a7ca5260"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Search, Refresh } from '@element-plus/icons-vue';
import { Icon } from '@iconify/vue';
import { getPermissionMenu } from '@/api/user';
import { deletePermissionMenu, updatePermissionMenu } from '@/api/permission';
import MenuCom from './components/Menu';
import distributePermission from './components/Permission';
import { treeToList } from '@/utils/flatTree';
import { arrayToTree } from '@/utils/arrayToTree';

// const defaultProps = {
//   children: 'childSysMenus',
//   label: 'remark'
// }

export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const loading = ref(false);
    const data = ref([]);
    const _getPermissionMenuList = async () => {
      loading.value = true;
      const res = await getPermissionMenu();
      tableData.value = res;
      data.value = tableData.value;
      loading.value = false;
    };
    _getPermissionMenuList();

    // tree 节点
    // const treeRef = ref(null)

    const filterText = ref('');
    const filterData = () => {
      if (!filterText.value) return tableData.value;
      const filterList = [];
      const list = treeToList(tableData.value);
      const searchList = list.filter(item => {
        return item.remark.includes(filterText.value);
      });
      console.log(searchList, 'searchList');
      if (searchList.length) {
        searchList.forEach(item => {
          filterList.push(generateFilterData(item, list));
        });
      }
      let data = [];
      const tmp = [];
      filterList.forEach(item => {
        tmp.push(...item);
      });
      data = new Set(tmp.map(item => item.id));
      data = Array.from(data).map(item => {
        return tmp.find(v => v.id === item);
      });
      console.log(data);
      return filterList.length && arrayToTree(data, 'id', 'parentId', 'childSysMenus');
    };
    const generateFilterData = (item, list) => {
      const data = [];
      data.push(item);
      if (item.parentId && item.parentId !== '0') {
        data.push(...generateFilterData(list.find(val => val.id === item.parentId), list));
      }
      return data;
    };
    const handleSearch = () => {
      data.value = filterData();
    };
    const handleRefreshSearch = () => {
      filterText.value = '';
      handleSearch();
    };

    // const filterNode = (value, data) => {
    //   if (!value) return true
    //   return data.remark.includes(value)
    // }
    const currentPermissionMenu = ref(null);
    const isAddOrEditPermissionMenuShow = ref(false);
    const addPermissionHandler = () => {
      isAddOrEditPermissionMenuShow.value = true;
    };
    const append = data => {
      currentPermissionMenu.value = data;
      isAddOrEditPermissionMenuShow.value = true;
    };
    const remove = data => {
      ElMessageBox.confirm('是否确认删除该条权限菜单', '温馨提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      }).then(() => {
        deletePermissionMenu(data.id).then(() => {
          ElMessage({
            type: 'success',
            message: '删除成功'
          });
          _getPermissionMenuList();
        });
      });
    };
    const clearModel = () => {
      currentPermissionMenu.value = null;
    };
    const isDistributePermissionShow = ref(false);
    const handleAssignPermission = data => {
      isDistributePermissionShow.value = true;
      currentPermissionMenu.value = data;
    };
    const handleDistributePermissionToMenu = async data => {
      const body = {
        id: currentPermissionMenu.value.id,
        permissionId: data.reduce((prev, item, index) => {
          return prev ? prev + ',' + item.permissionId : prev + item.permissionId;
        }, '')
      };
      await updatePermissionMenu(body);
      clearModel();
      _getPermissionMenuList();
    };
    const filterHandler = (value, row, column) => {
      console.log(value, row, column);
      const property = column['property'];
      return row[property] === value;
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: filterText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filterText.value = $event),
          placeholder: "请输入关键字",
          style: {
            "width": "300px",
            "margin-right": "20px"
          }
        }, null, 8, ["modelValue"]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: handleSearch
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefreshSearch
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addPermissionHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['permissionMenuAdd']]])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: data.value,
          style: {
            "width": "100%",
            "margin-bottom": "20px"
          },
          "row-key": "id",
          border: "",
          "tree-props": {
            children: 'childSysMenus',
            hasChildren: 'hasChildren'
          },
          "default-expand-all": "",
          "filter-method": filterHandler
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "remark",
            label: "菜单标题"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "菜单标识"
          }), _createVNode(_component_el_table_column, {
            prop: "url",
            label: "路由地址",
            "min-width": "120"
          }), _createVNode(_component_el_table_column, {
            label: "图标"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_unref(Icon), {
              icon: `icon-park-outline:${row.iconUrl}`
            }, null, 8, ["icon"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "图标"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "success",
              size: "small",
              style: {
                "margin-left": "8px"
              },
              onClick: _withModifiers($event => handleAssignPermission(row), ["stop"])
            }, {
              default: _withCtx(() => [_createTextVNode(" 后台权限分配 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['menuAssignPermission']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: _withModifiers(() => {
                append(row);
              }, ["stop"])
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['permissionMenuUpdate']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "danger",
              size: "small",
              style: {
                "margin-left": "8px"
              },
              onClick: _withModifiers(() => {
                remove(row);
              }, ["stop"])
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['permissionMenuDelete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }), _createVNode(_unref(MenuCom), {
        model: currentPermissionMenu.value,
        modelValue: isAddOrEditPermissionMenuShow.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isAddOrEditPermissionMenuShow.value = $event),
        onRefreshData: _getPermissionMenuList,
        onClearModel: clearModel,
        data: tableData.value
      }, null, 8, ["model", "modelValue", "data"]), _createVNode(_unref(distributePermission), {
        modelValue: isDistributePermissionShow.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => isDistributePermissionShow.value = $event),
        onDistributePermissionToMenu: handleDistributePermissionToMenu,
        model: currentPermissionMenu.value
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};